import type { History } from 'history';

function connectHistory(sourceHistory: History, targetHistory: History, { include }: { include?: string } = {}) {
  const includePath = include;

  return sourceHistory.listen(() => {
    if (outOfListenScope()) return;

    // TODO: 后期需要在加上search和hash
    // search已加，TODO: 后期需要在加上hash
    targetHistory.replace(sourceHistory.location.pathname + sourceHistory.location.search);
  });

  function outOfListenScope() {
    return includePath && sourceHistory.location.pathname.indexOf(includePath) !== 0;
  }
}

export default connectHistory;
